<template>
  <span>{{ formatted }}</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface Formatters {
  [currency: string]: Function,
}

const formatters: Formatters = {
  cad(amount: string): string {
    return `$${amount} CAD`;
  },
  usd(amount: string): string {
    return `$${amount} USD`;
  },
};

export default defineComponent({
  props: {
    currency: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    formatted(): string {
      let amount;
      if (this.amount === 0) {
        amount = '0.00';
      } else {
        amount = (this.amount / 100).toFixed(2);
      }
      if (formatters[this.currency]) {
        return formatters[this.currency](amount);
      }
      return amount;
    },
  },
});
</script>
